import { useDailyEvent, useInputSettings } from "@daily-co/daily-react";

/**
 * Hook to handle DailyCo events for SuperClinical video calls.
 * Sends video call event messages through the UniversalClinicChat socket.
 */
export const useUniversalClinicDailyEventHandling = () => {
  const { updateInputSettings } = useInputSettings();

  // Handle when provider joins the video call
  useDailyEvent("joined-meeting", () => {
    // Enable background blur for provider video
    updateInputSettings({
      video: {
        processor: {
          type: "background-blur",
          config: { strength: 1 },
        },
      },
    });
  });
};
